import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const CompetitorTrendChart = () => {
  // Dummy Data
  const categories = ["AI Boom", "Green Tech", "Space Race", "Crypto Shift"];
  const series = [
    {
      name: "Competitor A",
      data: [45, 55, 25, 70], // Engagement levels for Competitor A
    },
    {
      name: "Competitor B",
      data: [50, 40, 60, 50], // Engagement levels for Competitor B
    },
    {
      name: "Competitor C",
      data: [30, 60, 45, 40], // Engagement levels for Competitor C
    },
  ];

  // Highcharts Configuration
  const options = {
    chart: {
      type: "bar", // Stacked bar chart
    },
    title: {
      text: "",
    },
    // subtitle: {
    //   text: "Highlights trends that competitors are engaging with, showing what might be working in their favor.",
    // },
    xAxis: {
      categories: categories, // Trend names
      title: {
        text: "Trends",
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Engagement Level",
      },
      labels: {
        overflow: "justify",
      },
    },
    tooltip: {
      pointFormat:
        '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>',
      shared: true,
    },
    plotOptions: {
      series: {
        stacking: "normal", // Enable stacking
        dataLabels: {
          enabled: true, // Show values on bars
        },
      },
    },
    legend: {
      title: {
        text: "Competitors",
      },
    },
    series: series,
    credits: {
      enabled: false, // Disable Highcharts.com watermark
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default CompetitorTrendChart;
